import teamInviteService from '@/api/teaminvite'
import errorhandler from '@/utils/errorhandler.js'
import { TEAM } from '../types'

export default {
  namespaced: true,
  state: {
    invites: []
  },
  mutations: {
    [TEAM.SET_INVITES](state, invites){
      state.invites = invites
    }
  },
  actions: {
    getInviteList({commit, dispatch}) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve) => {
        teamInviteService.getInvites().then((response) =>{
          commit(TEAM.SET_INVITES, response.data)
          resolve()
        }).finally(() =>{
          dispatch('Global/hideLoading', null, { root: true })
        })
      })
    },
    async acceptInvite({dispatch}, inviteId) {
      dispatch('Global/showLoading', null, {root: true})
      try {      
        await teamInviteService.acceptInvite(inviteId)
        await dispatch('getInviteList')
        dispatch('Global/showMessage', 'saveSucessful', {root: true})
      }
      catch(response){
        errorhandler.handleError(response)
      }
      finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
    async refuseInvite({dispatch}, inviteId) {
      dispatch('Global/showLoading', null, {root: true})
      try {      
        await teamInviteService.refuseInvite(inviteId)
        await dispatch('getInviteList')
        dispatch('Global/showMessage', 'saveSucessful', {root: true})
      }
      catch(response){
        errorhandler.handleError(response)
      }
      finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
    async deleteInvite({dispatch}, inviteId) {
      dispatch('Global/showLoading', null, {root: true})
      try {      
        await teamInviteService.deleteInvite(inviteId)
        await dispatch('getInviteList')
        dispatch('Global/showMessage', 'successfullyRemoved', {root: true})
      }
      catch(response){
        errorhandler.handleError(response)
      }
      finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
    async getInviteDetails(_, filter) {
      try {
        const response = await teamInviteService.getInviteDetails(filter)
        const inviteDetails = response.data

        return inviteDetails
      } catch (error) {
        errorhandler.handleError(error)
      }
    }
  }
}